module.exports = __webpack_public_path__ + "static/media/download.8f722a0a.svg";